module.exports = __webpack_public_path__ + "static/media/St Peters Cathedral Logo.03bc1c8d.png";